module.exports = __webpack_public_path__ + "img/symbol_0.cd69b7ad.png";